export const updateCheckedOrders = (ids) => {
    return {
        type : 'UPDATE_CHECKED_ORDERS',
        payload : {
            ids
        }
    }
}

export const changeOrderState = (ids, state) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();


        ids && ids.map(id  => {
            const orderRef = firebase.ref().child(`orders/${id}`);
            orderRef.update({
                status : state
            }, ()=>{
                console.log('order state updated');
            })
                .catch((e) => {
                    console.log('order state update failed');
                })
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/Admin/OrderManager/actions/ordersAction.js